import React from 'react'
import css from './index.module.less'

const NotFound=()=>{
  return (
    <div className={css.container}>
      <div>
        <svg aria-hidden="true" style={{ width: 500, height: 210 }}>
          <use xlinkHref="#iconicon-test" ></use>
        </svg>
      </div>
      <p>很抱歉，页面它不小心迷路了～</p>
    </div>
  )
}

export default NotFound